import { render, staticRenderFns } from "./PackageColumns.vue?vue&type=template&id=05b8deaf&"
import script from "./PackageColumns.vue?vue&type=script&lang=js&"
export * from "./PackageColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports